'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var lastId = 0;

exports.default = function () {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'sg';

  lastId++;
  return '' + prefix + lastId;
};